export default "__VITE_ASSET__610cd155__"